import { useAuth } from '../../../contexts/AuthContext';

interface AdminHeaderProps {
  isCollapsed: boolean;
  onOpenMobileSidebar?: () => void;
}

export const AdminHeader = ({ isCollapsed, onOpenMobileSidebar }: AdminHeaderProps) => {
  const { user, profile } = useAuth();

  const displayName = profile?.display_name || profile?.full_name || user?.email?.split('@')[0] || 'Admin';
  const avatarUrl = profile?.avatar_url ?? null;
  const initials = displayName.slice(0, 2).toUpperCase();

  return (
    <header
      className={`fixed top-0 right-0 h-[72px] bg-[#0F0F1A] border-b border-white/10 z-30 flex items-center px-3 md:px-6 gap-3 transition-all duration-300 left-0 ${
        isCollapsed ? 'lg:left-[68px]' : 'lg:left-[260px]'
      }`}
    >
      {/* Mobile hamburger */}
      <button
        onClick={onOpenMobileSidebar}
        className="lg:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-white/10 text-white/60 cursor-pointer shrink-0"
      >
        <i className="ri-menu-line text-xl" />
      </button>

      <div className="flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-[11px] font-600 bg-violet-600/20 text-violet-400 px-2 py-0.5 rounded-full uppercase tracking-wider whitespace-nowrap">
            Master Admin
          </span>
          <span className="text-white/30 text-xs hidden md:block">Painel Administrativo do SaaS</span>
        </div>
      </div>

      <div className="flex items-center gap-2 md:gap-3">
        <button className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-white/10 text-white/50 transition-colors cursor-pointer">
          <i className="ri-notification-3-line text-[18px]" />
        </button>
        <div className="flex items-center gap-2">
          {/* Avatar real do perfil */}
          <div className="w-8 h-8 rounded-full overflow-hidden shrink-0 bg-violet-600/30 flex items-center justify-center">
            {avatarUrl ? (
              <img src={avatarUrl} alt={displayName} className="w-8 h-8 object-cover object-top" />
            ) : (
              <span className="text-white text-[12px] font-700">{initials}</span>
            )}
          </div>
          <div className="hidden md:block">
            <p className="text-[13px] font-600 text-white leading-tight">{displayName}</p>
            <p className="text-[11px] text-white/40">master_admin</p>
          </div>
        </div>
      </div>
    </header>
  );
};
